import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Mail } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../config/api';

export default function ForgotPassword() {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email: data.email });
      // Anti-enumeration: always show same message
      toast.success('Если такой email существует, мы отправили ссылку для сброса пароля.');
    } catch (e) {
      // Still show generic message
      toast.success('Если такой email существует, мы отправили ссылку для сброса пароля.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-secondary-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-secondary-900">Забыли пароль?</h2>
          <p className="mt-2 text-secondary-600">
            Введите ваш email — мы отправим ссылку для сброса пароля.
          </p>
        </div>

        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-secondary-700 mb-2">
              Email
            </label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-secondary-400 w-5 h-5" />
              <input
                id="email"
                type="email"
                {...register('email', {
                  required: 'Email обязателен',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Неверный формат email'
                  }
                })}
                className="input pl-10"
                placeholder="your@email.com"
              />
            </div>
            {errors.email && <p className="mt-1 text-sm text-orange-600">{errors.email.message}</p>}
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="btn btn-primary w-full flex items-center justify-center"
          >
            {isLoading ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Отправляем...
              </>
            ) : (
              'Отправить ссылку'
            )}
          </button>
        </form>

        <div className="text-center text-sm">
          <Link to="/login" className="text-primary-600 hover:text-primary-500 font-medium">
            Назад ко входу
          </Link>
        </div>
      </div>
    </div>
  );
}
